// apps/admin/src/features/businessses/components/BusinessPage.tsx
import Businesses from './Businesses';
import { useSetPageMeta } from '../../../hooks/usePageMeta';

/**
 * BusinessPage - A page wrapper component for the Business feature
 * 
 * This component serves as the main entry point for the businesss system.
 * It wraps the Business component with its dedicated BusinessDataProvider to ensure
 * proper context isolation from the original businesss system.
 * 
 * Note: JobsProviderWrapper is now provided at the route level in App.tsx
 * 
 * Key Features:
 * - Provides isolated data context for Business operations
 * 
 * Usage:
 * - Use this component in routing (see App.tsx route: /businesses)
 * - Do not use the raw Businesses component directly without this wrapper
 * - The provider ensures all business-related hooks have proper context access
 *
 * @returns JSX element containing the businesses management interface
 */
export default function BusinessesPage() {
  // Set page metadata
  useSetPageMeta({
    title: 'Service Providers',
    description: 'Manage service provider businesses'
  });
  
  return <Businesses />;
}
